<loader-pane-fragment *ngIf="traceName" [trace]="traceName"></loader-pane-fragment>
<top-menu></top-menu>
<mobile-menu></mobile-menu>
<joi-nav-wrapper 
  class="icon-tabs"
  [simple]="true"
  [menuItems]="subTabs"
  [menuMap]="entityConfigureSubpageNames"
  [selectedId]="subTab" 
  (selectItem)="subTab = $event"
></joi-nav-wrapper>
<div class="wrap920" *ngIf="!!event">
  <ng-container *ngIf="subTab === 'customQuestions'">
    <tip-text [type]="'tip'" [head]="'Tip:'" 
      [body]="'Questions created will appear in the ' + entityType + ' profile webform and / or SUBMISSIONS based on ' + entityType + '  type'">
    </tip-text>
    <h1 class="mt-20">Custom Questions for {{ entityType | titlecase }} Profile</h1>
    <custom-question-manager 
      [entityType]="entityType"
    ></custom-question-manager>
  </ng-container>
  <ng-container *ngIf="subTab === 'briefInfo'">
    <tip-text [type]="'tip'" [head]="'Tip:'" 
      [body]="'Information entered here will appear in the ' + entityType + ' brief based on ' + entityType + ' type'">
    </tip-text>
    <h1 class="mt-20">Event Information</h1>
    <informable 
      [informableType]="informableType" 
      [allCollapse]="true"
      [useAssetIds]="true"
      [assetEntityHolderName]="entityType + ' information'"
      [entityType]="entityType"
    ></informable>

    <ng-container *ngIf="{ showPrograms: event[showPublishesKey] } as vars">
      <h1 class="mt-40">Published Program</h1>
      <title-toggle-wrapper
        [title]="'Include published program(s) in ' + entityType + ' brief'"
        [hideBottom]="false"
        [toggleOn]="vars.showPrograms"
        (toggle)="toggleIncludePublishes($event)"
      >
        <div *ngIf="!vars.showPrograms">Turn this area on to give your performers access to a published program. Selected pages will be included in their {{ entityTitle }} Brief.</div>
        <ng-container *ngIf="vars.showPrograms">
          <div class="missing" *ngIf="!publishes.length">There aren’t any published pages to include. Go to <em>Publish</em>, then create a page and publish it.</div>
          <ng-container *ngIf="!!publishes.length">
            <div class="instructions">Select the published program pages(s) you would like to include in the {{ entityType }} brief.</div>
            <title-status-toggle
              *ngFor="let publish of publishes" 
              [title]="publish.title"
              [hideToggle]="publish.status !== 'published'"
              [status]="publish.status"
              [statusColor]="colorsByPublishStatus[publish.status]"
              [toggleOn]="publish.on"
              (toggle)="togglePublish(publish.publishCode)"
            >
              <type-select-dropdown class="afterTitle" *ngIf="entityType"
                [ids]="event?.publishEntityKeys[entityType + '-' + publish.publishCode] || []"
                [entityType]="entityType"
                [types]="entityTypes"
                (selectIds)="updatePublishEntityTypes(publish, $event)"
              ></type-select-dropdown>
            </title-status-toggle>
          </ng-container>
        </ng-container>
      </title-toggle-wrapper>
    </ng-container>

    <ng-container *ngIf="{ showLogistics: event[showLogisticsKey] } as vars">
      <h1 class="mt-40">Production Views</h1>
      <title-toggle-wrapper
        [title]="'Include production views(s) in ' + entityType + ' brief'"
        [hideBottom]="false"
        [toggleOn]="vars.showLogistics"
        (toggle)="toggleIncludeLogistics($event)"
      >
        <div *ngIf="!vars.showLogistics">Turn this area on to give your {{ entityType }}s access to a production view. Selected pages will be included in their {{ entityTitle }} Brief.</div>
        <ng-container *ngIf="vars.showLogistics">
          <div class="missing" *ngIf="!logistics.length">There aren’t any production views to include. Go to <em>Production Share</em>, then create a view and share it.</div>
          <ng-container *ngIf="!!logistics.length">
            <div class="instructions">Select the production views(s) you would like to include in the {{ entityType }} brief.</div>
            <title-status-toggle
              *ngFor="let log of logistics" 
              [title]="log.title"
              [hideToggle]="log.status !== 'shared'"
              [status]="log.status"
              [statusColor]="shareStatusToColor[log.status]"
              [toggleOn]="log.on"
              (toggle)="toggleLogistics(log.code)"
            >
              <type-select-dropdown class="afterTitle" *ngIf="entityType"
                [ids]="event?.logisticsEntityKeys[entityType + '-' + log.code] || []"
                [entityType]="entityType"
                [types]="entityTypes"
                (selectIds)="updateLogisticsEntityTypes(log, $event)"
              ></type-select-dropdown>
            </title-status-toggle>
          </ng-container>
        </ng-container>
      </title-toggle-wrapper>
    </ng-container>

    <ng-container *ngIf="{ showShares: event[showShareKey] } as vars">
      <h1 class="mt-40">Onsite Shares</h1>
      <title-toggle-wrapper
        [title]="'Include onsite shares(s) in ' + entityType + ' brief'"
        [hideBottom]="false"
        [toggleOn]="vars.showShares"
        (toggle)="toggleIncludeShares($event)"
      >
        <div *ngIf="!vars.showShares">Turn this area on to give your {{ entityType }}s access to an onsite share. Selected pages will be included in their {{ entityTitle }} Brief.</div>
        <ng-container *ngIf="vars.showShares">
          <div class="missing" *ngIf="!shares.length">There aren’t any onsite shares to include. Go to <em>Onsite Schedules</em>, then create a view and share it.</div>
          <ng-container *ngIf="!!shares.length">
            <div class="instructions">Select the onsite shares(s) you would like to include in the {{ entityType }} brief.</div>
            <title-status-toggle
              *ngFor="let log of shares" 
              [title]="log.title"
              [hideToggle]="log.status !== 'shared'"
              [status]="log.status"
              [statusColor]="shareStatusToColor[log.status]"
              [toggleOn]="log.on"
              (toggle)="toggleShares(log.code)"
            >
              <type-select-dropdown class="afterTitle" *ngIf="entityType"
                [ids]="event?.shareEntityKeys[entityType + '-' + log.code] || []"
                [entityType]="entityType"
                [types]="entityTypes"
                (selectIds)="updateShareEntityTypes(log, $event)"
              ></type-select-dropdown>
            </title-status-toggle>
          </ng-container>
        </ng-container>
      </title-toggle-wrapper>
    </ng-container>

    <h1 class="mt-40">Terms</h1>
    <media-terms *ngFor="let terms of mediaTerms" [terms]="terms" [entityTypesMap]="entityTypes" [type]="entityType"></media-terms>
    <button mat-button class="large" *ngIf="!readOnly" (click)="addTerms()">+ Add additional terms</button>
  </ng-container>
  <submitted-entities *ngIf="subTab === 'submissions'" [entityType]="entityType"></submitted-entities>
</div>